(function () {
  'use strict';

  var STORAGE_KEY = 'veluxis-wishlist';

  /* ── Storage helpers ───────────────────────────────────────── */

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function isInWishlist(variantId) {
    return getWishlist().some(function (item) {
      return String(item.variantId) === String(variantId);
    });
  }

  function addToWishlist(data) {
    var items = getWishlist();
    if (!isInWishlist(data.variantId)) {
      items.push(data);
      saveWishlist(items);
    }
  }

  function removeFromWishlist(variantId) {
    var items = getWishlist().filter(function (item) {
      return String(item.variantId) !== String(variantId);
    });
    saveWishlist(items);
  }

  function toggleWishlist(data) {
    if (isInWishlist(data.variantId)) {
      removeFromWishlist(data.variantId);
      return false;
    } else {
      addToWishlist(data);
      return true;
    }
  }

  /* ── Button state ──────────────────────────────────────────── */

  function updateButtonState(btn) {
    var variantId = btn.dataset.variantId;
    if (isInWishlist(variantId)) {
      btn.classList.add('is-active');
      btn.setAttribute('aria-label', 'Remove from wishlist');
    } else {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-label', 'Add to wishlist');
    }
  }

  function syncAllButtons(variantId) {
    document.querySelectorAll('.wishlist-btn[data-variant-id="' + variantId + '"]').forEach(function (btn) {
      updateButtonState(btn);
    });
  }

  /* ── Init buttons on the page ──────────────────────────────── */

  function attachButtonHandler(btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var data = {
        variantId:    btn.dataset.variantId,
        handle:       btn.dataset.productHandle,
        title:        btn.dataset.productTitle,
        url:          btn.dataset.productUrl,
        image:        btn.dataset.productImage,
        price:        btn.dataset.productPrice,
        comparePrice: btn.dataset.comparePrice,
        productId:    btn.dataset.productId,
        currency:     btn.dataset.currency
      };

      toggleWishlist(data);
      syncAllButtons(data.variantId);
    });
  }

  function initButtons() {
    document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
      updateButtonState(btn);
      attachButtonHandler(btn);
    });
  }

  /* ── Wishlist page rendering ───────────────────────────────── */

  function formatMoney(cents, currency) {
    var amount = parseInt(cents, 10);
    if (!amount) return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(amount);
    }
    return (currency || '€') + (amount / 100).toFixed(2);
  }

  function heartSVG() {
    return '<svg class="heart-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'
      + '<path class="heart-icon__path" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>'
      + '</svg>';
  }

  function renderCard(item, cardStyle, colorScheme) {
    var hasSale = item.comparePrice && parseInt(item.comparePrice, 10) > parseInt(item.price, 10);

    var priceHtml = hasSale
      ? '<div class="price price--on-sale"><div class="price__container">'
          + '<div class="price__sale"><span class="visually-hidden">Sale price</span>'
          + '<span class="price-item price-item--sale">' + formatMoney(item.price, item.currency) + '</span></div>'
          + '<div class="price__compare"><span class="visually-hidden">Regular price</span>'
          + '<span class="price-item price-item--regular">' + formatMoney(item.comparePrice, item.currency) + '</span></div>'
          + '</div></div>'
      : '<div class="price"><div class="price__container">'
          + '<div class="price__regular">'
          + '<span class="price-item price-item--regular">' + formatMoney(item.price, item.currency) + '</span>'
          + '</div></div></div>';

    var imageHtml = item.image
      ? '<img src="' + item.image + '" alt="' + (item.title || '') + '" loading="lazy" width="533" height="533">'
      : '';

    var innerColorClass = cardStyle === 'standard' ? colorScheme + ' gradient' : '';

    return '<li class="grid__item scroll-trigger animate--slide-in">'
      + '<div class="card-wrapper product-card-wrapper underline-links-hover">'
      + '<div class="card card--' + cardStyle + ' card--media ' + colorScheme + ' gradient">'
      + '<div class="card__inner ' + innerColorClass + ' ratio" style="--ratio-percent: 100%;">'
      + '<div class="card__media"><div class="media media--transparent media--hover-effect">'
      + imageHtml
      + '</div></div>'
      + '<button type="button" class="wishlist-btn is-active"'
      + ' data-variant-id="' + item.variantId + '"'
      + ' data-product-handle="' + (item.handle || '') + '"'
      + ' data-product-title="' + (item.title || '') + '"'
      + ' data-product-url="' + (item.url || '') + '"'
      + ' data-product-image="' + (item.image || '') + '"'
      + ' data-product-price="' + (item.price || '') + '"'
      + ' data-compare-price="' + (item.comparePrice || '') + '"'
      + ' data-product-id="' + (item.productId || '') + '"'
      + ' data-currency="' + (item.currency || '') + '"'
      + ' aria-label="Remove from wishlist">'
      + heartSVG()
      + '</button>'
      + '</div>'
      + '<div class="card__content"><div class="card__information">'
      + '<h3 class="card__heading h5">'
      + '<a href="' + (item.url || '/') + '" class="full-unstyled-link">' + (item.title || '') + '</a>'
      + '</h3>'
      + '<div class="card-information">' + priceHtml + '</div>'
      + '</div></div>'
      + '</div></div>'
      + '</li>';
  }

  function checkEmptyState() {
    var grid  = document.getElementById('product-grid');
    var empty = document.getElementById('wishlist-empty');
    if (!grid || !empty) return;
    empty.style.display = grid.children.length === 0 ? 'block' : 'none';
  }

  function attachWishlistPageHandler(btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.dataset.variantId;
      removeFromWishlist(variantId);
      syncAllButtons(variantId);
      var li = btn.closest('li.grid__item') || btn.closest('.card-wrapper');
      if (li) li.remove();
      checkEmptyState();
    });
  }

  function initWishlistPage() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var container   = document.querySelector('.section-wishlist__grid');
    var cardStyle   = container ? (container.dataset.cardStyle   || 'standard')     : 'standard';
    var colorScheme = container ? (container.dataset.colorScheme || 'color-scheme-1') : 'color-scheme-1';
    var empty       = document.getElementById('wishlist-empty');
    var items       = getWishlist();

    if (items.length === 0) {
      if (empty) empty.style.display = 'block';
      return;
    }

    items.forEach(function (item) {
      grid.insertAdjacentHTML('beforeend', renderCard(item, cardStyle, colorScheme));
    });

    grid.querySelectorAll('.wishlist-btn').forEach(function (btn) {
      attachWishlistPageHandler(btn);
    });
  }

  /* ── Boot ──────────────────────────────────────────────────── */

  document.addEventListener('DOMContentLoaded', function () {
    initButtons();
    initWishlistPage();
  });

  // Re-init when theme editor reloads a section
  document.addEventListener('shopify:section:load', function () {
    initButtons();
  });
})();
